'use strict';

const _ = require('underscore');
const HolyMenu = require('common/ui/view/svg/menu/holy');
const MenuIcon = require('common/ui/view/svg/menu/icon');
const ElementAction = require('system/domain/action/element');
const TagBulkEditModalView = require('system/ui/view/modal/tag-bulk-edit');
const OwnerBulkEditModalView = require('system/ui/view/modal/owner-bulk-edit');

module.exports = HolyMenu.extend({
    initialize: function(params) {
        this.constructor.__super__.initialize.call(this, params);
        _.bindAll(this, '_tag', '_owner', '_invert', '_comment');
        this._channel = params.channel;
        this._context = params.context;
        this._group = params.group;
        this._project = params.project;

        this.menus = [
            {
                name: 'tag',
                icon: MenuIcon.fontAwesomeIcon(
                    'fa fa-tag',
                    {
                        color: '#888'
                    }
                ),
                click: this._tag,
                text: 'view/diagram:menu.multi.tag'
            },
            {
                name: 'owner',
                icon: MenuIcon.fontAwesomeIcon(
                    'fa fa-user',
                    {
                        color: '#888'
                    }
                ),
                click: this._owner,
                text: 'view/diagram:menu.multi.owner'
            },
            {
                name: 'invert',
                icon: MenuIcon.fontAwesomeIcon(
                    'fa fa-exchange',
                    {
                        color: '#888'
                    }
                ),
                click: this._invert,
                text: 'view/diagram:menu.multi.invert'
            },
            {
                name: 'comment',
                icon: MenuIcon.fontAwesomeIcon(
                    'fa fa-comment',
                    {
                        color: '#888'
                    }
                ),
                click: this._comment,
                text: 'view/diagram:menu.multi.comment'
            }
        ]
    },

    _tag: function() {
        const nodes = this._channel.request(
            'req:nodes:selected');
        const view = new TagBulkEditModalView({
            nodes: nodes,
            context: this._context
        });

        $('#modal-container').append(view.render().el);
        view.show();
    },

    _owner: function() {
        const nodes = this._channel.request(
            'req:nodes:selected');
        const view = new OwnerBulkEditModalView({
            nodes: nodes,
            context: this._context,
            group: this._group,
            project: this._project
        });

        $('#modal-container').append(view.render().el);
        view.show();
    },

    _invert: function() {
        const links = this._channel.request(
            'req:links:selected');
        ElementAction.invertLink({
            context: this._context,
            link: _.map(links, function(l) {return l.toJSON();})
        });
    },

    _comment: function() {
        const nodes = this._channel.request(
            'req:nodes:selected');
        const links = this._channel.request(
            'req:links:selected');
        this._channel.trigger('append:comment:records', nodes);
        this._channel.trigger('append:comment:relations', links);
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/menu/multi-edit.js